// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BooksIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.956 24.319 24.808 4.594a2.002 2.002 0 0 0-2.375-1.549L16.58 4.303a2.01 2.01 0 0 0-1.537 2.375l4.148 19.724a2 2 0 0 0 2.375 1.553l5.852-1.257a2.011 2.011 0 0 0 1.537-2.38ZM17 6.269v-.011l5.85-1.25.416 1.983-5.85 1.259L17 6.269Zm.828 3.934 5.852-1.257.418 1.988-5.848 1.257-.422-1.989Zm.83 3.946 5.852-1.258 1.662 7.905-5.852 1.258-1.663-7.905ZM27 24.743l-5.85 1.25-.416-1.984 5.85-1.259.416 1.981v.011ZM13 4H7a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM7 6h6v2H7V6Zm0 4h6v12H7V10Zm6 16H7v-2h6v2Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
